import Base from './Base';
import DateFormats from './DateFormats';

export default class MaintenanceInvoiceFile extends Base {
  id: number;
  areaId: number;
  contactId: number;
  dateFile: string;
  description: string;
  fileclass: string;
  filename: string;
  filesize: number;
  keyname: string;
  mimetype: string;
  portal: number;

  constructor(data: any) {
    super();
    this.id = data.id;
    this.areaId = data.areaId;
    this.contactId = data.contactId;
    this.dateFile = data.dateFile;
    this.description = data.description;
    this.fileclass = data.fileclass;
    this.filename = data.filename;
    this.filesize = data.filesize;
    this.keyname = data.keyname;
    this.mimetype = data.mimetype;
    this.portal = data.portal;
  }

  static parseFromData(data: any): MaintenanceInvoiceFile {
    return new MaintenanceInvoiceFile({
      id: data.id,
      areaId: data.area_id,
      contactId: data.contact_id,
      dateFile: data.date_file,
      description: data.description,
      fileclass: data.fileclass,
      filename: data.filename,
      filesize: data.filesize,
      keyname: data.keyname,
      mimetype: data.mimetype,
      portal: data.portal,
    });
  }

  getFileSize(): string {
    const units = ['bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

    let l = 0;
    let bytes = this.filesize || 0;
    while (bytes >= 1024 && ++l) {
      bytes = bytes / 1024;
    }

    return bytes.toFixed(bytes < 10 && l > 0 ? 1 : 0) + ' ' + units[l];
  }

  getFileDate(dateFormat: string): string {
    return this.getDateFromSQL(
      this.dateFile,
      dateFormat || DateFormats.DATE_FULL
    );
  }
}
